module.exports = __webpack_public_path__ + "static/media/beneficiary.20ca472f.svg";